<template>
    <framed-layout>

        <template #right>
            <a @click="goBack" class="btn-circle cursor-pointer">
                <i class="text-xl text-blue-500 pi pi-times"></i>
            </a>
        </template>

        <div class="max-w-5xl mx-auto">
          <profile/>
        </div>
    </framed-layout>
</template>

<script>
import FramedLayout from './../Layouts/FramedLayout'
import Profile from './../components/Profile'

export default {
    components: {
        FramedLayout,
        Profile
    },
    methods: {
        goBack() {
            this.$router.push('/projects');
        },
    },
}
</script>
